/**
 * normaliserZone — convertit la zone sismique vers le format romain unifié
 *
 * Marché FR : form stocke "1".."5" (chiffres arabes, EC8)
 * Marché DZ : form stocke "I".."VI" (chiffres romains, RPA 2024)
 * Toutes les règles KB comparent en chiffres romains → normalisation à la source.
 */
export const normaliserZone = (zone) => {
  if (!zone) return "";
  const z = zone.toString().replace("Zone ", "").replace("Z", "").trim();
  const map = { "1":"I", "2":"II", "3":"III", "4":"IV", "5":"V", "6":"VI" };
  return map[z] || z;
};
